export const SectionHeading = ({ eyebrow, title, sub, dark = false, center = false }) => (
  <div className={center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
    {eyebrow && <p className={dark ? "eyebrow-dark" : "eyebrow"} data-testid="section-eyebrow">{eyebrow}</p>}
    <h2 className={`mt-4 font-display text-4xl leading-tight tracking-tight md:text-5xl ${dark ? "text-offwhite" : "text-charcoal"}`}>
      {title}
    </h2>
    {sub && (
      <p className={`mt-5 text-base leading-relaxed ${dark ? "text-white/70" : "text-charcoal/70"}`}>{sub}</p>
    )}
  </div>
);
